import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EndoDiagnosisDataModel} from '../../modules/forms/custom/diagnosis/models/endo-diagnosis-data.model';
import {EndoDiagnosisToothDetailDataModel} from '../../modules/forms/custom/diagnosis/models/endo-diagnosis-tooth-detail-data.model';
import {DiagnosisDifficultyConfigurationModel} from '../../models/forms/custom/diagnosis/diagnosis-difficulty-configuration.model';
import {EndoDiagnosisPriorTreatmentDataModel} from '../../modules/forms/custom/diagnosis/models/endo-diagnosis-prior-treatment-data.model';
import { DataPatientCaseModel } from 'src/app/models/accountsReceivable/data-patient-case.model';
import { PatientCaseWorkItemFormDataModel } from 'src/app/models/forms/data/patient-case-work-item-form-data.model';

@Injectable({
  providedIn: 'root'
})
export class DiagnosisService {

  constructor(private readonly http: HttpClient) { }

  getDiagnosis(patientId: string, caseWorkItemFormsId: string) {
    return this.http.get<EndoDiagnosisDataModel>(`api/diagnosis/get-diagnosis-form/${patientId}/${caseWorkItemFormsId}`);
  }

  getDiagnosisFormsForPatient(patientId: string) {
    return this.http.get<DataPatientCaseModel[]>(`api/diagnosis/get-diagnosis-form-by-PatientId/${patientId}`);
  }
  

  saveDiagnosis(model: EndoDiagnosisDataModel) {
    return this.http.post<EndoDiagnosisDataModel>(`api/diagnosis/save-diagnosis-form`, model);
  }

  completeEndoDiagnosisForm(endoDiagnosisId: string) {
    return this.http.get<void>(`api/diagnosis/complete-endo-diagnosis-form/${endoDiagnosisId}`);
  }

  saveDiagnosisDetail(model: EndoDiagnosisToothDetailDataModel) {
    return this.http.post<EndoDiagnosisToothDetailDataModel>(`api/diagnosis/save-diagnosis-detail`, model);
  }

  cloneDiagnosis(sourceDiagnosisId: string, targetCaseWorkItemForm : PatientCaseWorkItemFormDataModel[]) {
    return this.http.post<void>(`api/diagnosis/clone-diagnosos-form/${sourceDiagnosisId}`, targetCaseWorkItemForm);
  }

  getConfigs() {
    return this.http.get<DiagnosisDifficultyConfigurationModel[]>(`api/diagnosis/get-diagnosis-configs`);
  }

  saveConfig(model: DiagnosisDifficultyConfigurationModel) {
    return this.http.post<DiagnosisDifficultyConfigurationModel>(`api/diagnosis/save-diagnosis-config`, model);
  }

  getPriorTreatments(diagId: string) {
    return this.http.get<EndoDiagnosisPriorTreatmentDataModel[]>(`api/diagnosis/get-diagnosis-prior-treatments/${diagId}`);
  }

  savePriorTreatments(model: EndoDiagnosisPriorTreatmentDataModel) {
    return this.http.post<EndoDiagnosisPriorTreatmentDataModel>(`api/diagnosis/save-diagnosis-prior-treatment`, model);
  }

  deletePriorTreatments(model: EndoDiagnosisPriorTreatmentDataModel) {
    return this.http.post<EndoDiagnosisPriorTreatmentDataModel>(`api/diagnosis/delete-diagnosis-prior-treatment`, model);
  }
}
